import { useRef, useState, useLayoutEffect } from "react";
/**
 * Checks if the window matches any given width
 *
 * @param {number} width
 */

const useWindowWidth = width => {
    const mediaQuery = useRef(window.matchMedia(`(min-width: ${width}px)`));
    const [match, setMatch] = useState(mediaQuery.current.matches);
    const handleMatchToggle = ({ matches }) => setMatch(matches);

    useLayoutEffect(() => {
        const ref = mediaQuery.current;
        const supportsEventListener = ref && ref.addEventListener;
        handleMatchToggle(mediaQuery.current);
        if (supportsEventListener) ref.addEventListener("change", handleMatchToggle);
        else ref.addListener(handleMatchToggle);
        return () => {
            if (supportsEventListener) ref.removeEventListener("change", handleMatchToggle);
            else ref.removeListener(handleMatchToggle);
        };
    }, []);

    return match;
};

export default useWindowWidth;